import { messageBoxSuccess, messageBoxError } from '../message-box';
class CartHandler {
  private form: HTMLElement | null;
  private addToCartButton: HTMLElement | null;
  private cartUpdatedEvent: CustomEvent;
  private requiredAccessoriesEvent: CustomEvent;
  public cartIconHeader: HTMLElement | null;
  public cartIconHeaderInner: SVGTSpanElement | null | undefined;

  cache() {
    this.form = document.querySelector('.js-product-add-to-cart');

    if (this.form) {
      this.addToCartButton = this.form.querySelector('.js-product-add-to-cart-btn');
    }

    this.cartIconHeader = document.querySelector('.l-header__actions-button-cart .js-l-header__cart-icon');
    this.cartIconHeaderInner = this.cartIconHeader?.querySelector('tspan');
  }

  bindings() {
    if (this.form) {
      this.form.addEventListener('submit', (e: Event) => {
        e.preventDefault();

        // @ts-ignore
        const data = new FormData(this.form);

        this.addToCartButton?.classList.add('is-disabled');
        document.body.classList.add('loading-bar');
        const apiBaseUrl = document.body.dataset.apiBaseUrl;
        fetch(`${apiBaseUrl}`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: data,
        })
          .then((response) => response.json())
          .then((jsonResponse) => {
            //TODO Craft4 refactoring: successful response now has only 'cart' and 'modelName' as propertys
            if (jsonResponse.cart && jsonResponse.modelName) {
              if (jsonResponse.message) {
                messageBoxSuccess({
                  contentDe: jsonResponse.message,
                  contentEn: jsonResponse.message,
                });
              }

              if (this.cartIconHeader) {
                this.cartIconHeader.style.display = 'block';
              }

              // Update totals on header icon
              if (this.cartIconHeaderInner) {
                let sum = 0;
                let alreadyCounted: any[] = [];
                jsonResponse.cart.lineItems.forEach((lineItem: any) => {
                  if (!lineItem.options?._configuratorId || lineItem.options?._configuratorMainItem === 'yes') {
                    sum += lineItem.qty;
                  }
                  alreadyCounted.push(lineItem.options?._configuratorId);
                });
                this.cartIconHeaderInner.innerHTML = String(sum);
              }

              if (data.has('with-accessories') && data.get('with-accessories') != "") {
                this.requiredAccessoriesEvent.detail.products = JSON.stringify([
                  {
                    'id': data.get('with-accessories')?.toString(),
                    'quantity': data.get('purchasables[0][qty]')
                  }
                ]);
                this.requiredAccessoriesEvent.detail.quantity = [];
                document.dispatchEvent(this.requiredAccessoriesEvent);

                // Update Cart without open it
                let customCartUpdatedEvent = this.cartUpdatedEvent;
                customCartUpdatedEvent.detail.showCart = false;
                document.dispatchEvent(customCartUpdatedEvent);
              }
              else {
                document.dispatchEvent(this.cartUpdatedEvent);
              }

              // @ts-ignore
              if (this.addToCartButton?.dataset.products) {
                const rawProductData = JSON.parse(this.addToCartButton?.dataset.products);
                const selectedProduct = rawProductData[0];

                let currency = 'EUR';
                if (selectedProduct.price.currency == '$') {
                  currency = 'USD';
                }

                // @ts-ignore
                const quantity = this.form.querySelector('input[name="purchasables[0][qty]"]').value;

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null }); // reset data layer items
                window.dataLayer.push({
                  event: 'add_to_cart',
                  ecommerce: {
                    currency: currency, // currency
                    value: selectedProduct.price.price, // price including discount
                    content_type: 'product', // static
                    content_ids: [selectedProduct.sku], // SKU
                    items: [
                      {
                        item_id: selectedProduct.sku, // SKU
                        item_name: selectedProduct.title, // product name
                        item_category: selectedProduct.product_type_label, // product category (category ID would be fine as well)
                        configuration_id: null, // configuration ID, if applicable
                        price: selectedProduct.price.price, // original price
                        discount: null, // discount, if applicable
                        quantity: quantity // static
                      }
                    ]
                  }
                });
              }
            } else {
              let errorList = '';

              if (jsonResponse.errors) {
                Object.values(jsonResponse.errors).forEach((errors: any) => {
                  if (typeof errors === 'object') {
                    Object.values(errors).forEach((error: any) => {
                      errorList += `<br/> ${error}`;
                    });
                  }
                });
              }

              const message = `${jsonResponse.error.replace('.', '')}: ${errorList}`;

              messageBoxError({
                contentDe: message,
                contentEn: message,
              });
            }

            this.addToCartButton?.classList.remove('is-disabled');
            document.body.classList.remove('loading-bar');
          })
          .catch((error) => {
            console.error('Error:', error);

            this.addToCartButton?.classList.remove('is-disabled');
            document.body.classList.remove('loading-bar');
          });

      });
    }
  }

  createCartUpdatedEvent() {
    this.cartUpdatedEvent = new CustomEvent('cart:updated', {
      detail: { showCart: true },
    } as any);
  }

  createRequiredAccessoriesEvent() {
    this.requiredAccessoriesEvent = new CustomEvent('formpopup:open', {
      detail: {
        form: 'required-accessories',
        type: 'form',
        size: 'large--py-0',
        target: 'form-popup',
        products: ''
      },
    } as any);
  }

  init() {
    this.cache();
    this.bindings();
    this.createCartUpdatedEvent();
    this.createRequiredAccessoriesEvent();
  }
}

export default CartHandler;
